import { render, staticRenderFns } from "./ModalUpdateConfirmation.vue?vue&type=template&id=0dd72fc2&scoped=true&"
import script from "./ModalUpdateConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd72fc2",
  null
  
)

export default component.exports